import {
  getPage,
  getDetail,
  getClientPage,
  exportExcel,
} from '@/api/midnightspeedalarmanalysisresultserv'

export default {
  state: {
    state_MidnightSpeedAlarmAnalysisResult_GetPageResult: null,
    state_MidnightSpeedAlarmAnalysisResult_GetDetailResult: null,
    state_MidnightSpeedAlarmAnalysisResult_GetClientPageResult: null,
    state_MidnightSpeedAlarmAnalysisResult_ExportExcelResult: null,
  },
  mutations: {
    SET_MIDNIGHTSPEEDALARMANALYSISRESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_MidnightSpeedAlarmAnalysisResult_GetPageResult = rst;
    },
    SET_MIDNIGHTSPEEDALARMANALYSISRESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_MidnightSpeedAlarmAnalysisResult_GetDetailResult = rst;
    },
    SET_MIDNIGHTSPEEDALARMANALYSISRESULT_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_MidnightSpeedAlarmAnalysisResult_GetClientPageResult = rst;
    },
    SET_MIDNIGHTSPEEDALARMANALYSISRESULT_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_MidnightSpeedAlarmAnalysisResult_ExportExcelResult = rst;
    },
  },
  actions: {
    MidnightSpeedAlarmAnalysisResultServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MIDNIGHTSPEEDALARMANALYSISRESULT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MIDNIGHTSPEEDALARMANALYSISRESULT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MidnightSpeedAlarmAnalysisResultServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MIDNIGHTSPEEDALARMANALYSISRESULT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MIDNIGHTSPEEDALARMANALYSISRESULT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MidnightSpeedAlarmAnalysisResultServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MIDNIGHTSPEEDALARMANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MIDNIGHTSPEEDALARMANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MidnightSpeedAlarmAnalysisResultServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MIDNIGHTSPEEDALARMANALYSISRESULT_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MIDNIGHTSPEEDALARMANALYSISRESULT_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_MidnightSpeedAlarmAnalysisResult_GetPageResult: state => {
      return state.state_MidnightSpeedAlarmAnalysisResult_GetPageResult;
    },
    get_MidnightSpeedAlarmAnalysisResult_GetDetailResult: state => {
      return state.state_MidnightSpeedAlarmAnalysisResult_GetDetailResult;
    },
    get_MidnightSpeedAlarmAnalysisResult_GetClientPageResult: state => {
      return state.state_MidnightSpeedAlarmAnalysisResult_GetClientPageResult;
    },
    get_MidnightSpeedAlarmAnalysisResult_ExportExcelResult: state => {
      return state.state_MidnightSpeedAlarmAnalysisResult_ExportExcelResult;
    },
  }
}